import type { AccountStatement } from './types';

export interface StatementQuery {
  sid: number;
  anum: number;
  from: string;
  to: string;
  /** Optional agecode override; omit to use the account's effective code. */
  agecod?: number;
}

/**
 * v2.43 — Mexican AR statement ("Estado de cuenta") for one store+account.
 * Read-only; the daemon ports mexstate.p's ledger + aging + summary math.
 */
export async function fetchAccountStatement(q: StatementQuery): Promise<AccountStatement> {
  const params = new URLSearchParams({
    sid: String(q.sid),
    anum: String(q.anum),
    from: q.from,
    to: q.to,
  });
  if (q.agecod != null) params.set('agecod', String(q.agecod));
  const res = await fetch(`/api/account-statement?${params}`, { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error(res.status === 502 || res.status === 503
      ? '503: daemon offline'
      : `account-statement failed: ${res.status}`);
  }
  return (await res.json()) as AccountStatement;
}
